// tslint:disable:no-var-requires
require("../../lib/core");
require("../../framework/core");
require("./brand");
require("../../../Content/app/less/app.less");
require("../../framework");
require("./ui");
require("./core");
require("./searchTypes");

// The following are here only so that they end up in the core bundle
// when doing code splitting instead of in each bundle where they are used.
require("./app");
require("./cf");
require("./map/map");
require("./notes");
require("./page");
require("./rolesAndRights");
require("./helper/reportHelper");
require("./util/realTimeUpdates");
require("./common/portal");
require("./common/widgets");
